import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { tracked } from '@glimmer/tracking';
import { t } from 'ember-intl';
import Button from 'tio-ui/components/button';
import type { ButtonAppearance } from 'tio-ui/components/button';
import AddApplicationModal from './modal';
import type { EligibleTemplate, LiveTasProgram } from 'tio-employee/services/reimagined-data';

export interface AddApplicationButtonSignature {
  Args: {
    enrolledPrograms: LiveTasProgram[];
    eligibleTemplates: EligibleTemplate[];
    appearance?: ButtonAppearance;
  };
  Element: HTMLDivElement;
}

export default class AddApplicationButton extends Component<AddApplicationButtonSignature> {
  @tracked showModal = false;

  get appearance(): ButtonAppearance {
    return this.args.appearance ?? 'outlined';
  }

  openModal = () => {
    this.showModal = true;
  };

  closeModal = () => {
    this.showModal = false;
  };

  <template>
    <div ...attributes>
      <Button
        @intent="primary"
        @appearance={{this.appearance}}
        @size="sm"
        {{on "click" this.openModal}}
      >
        {{t "tuition_assistance.reimagined.dashboard.cta_add_application"}}
      </Button>
      <AddApplicationModal
        @isOpen={{this.showModal}}
        @onClose={{this.closeModal}}
        @enrolledPrograms={{@enrolledPrograms}}
        @eligibleTemplates={{@eligibleTemplates}}
      />
    </div>
  </template>
}
